import { translation } from '@/plugins/i18n';
import { dateTimeFormat } from '@/utils/dateformat';

const needParseErrorCodeMap = {
  general_error: 380001,
  expire_partner: 380002,
  with_partner: 380003,
};

const preciseMsgMapping = new Map([
  [needParseErrorCodeMap.with_partner, 'billing.coupon.error.with_partner'],
  [needParseErrorCodeMap.expire_partner, 'billing.partner.error.expire_partner'],
]);

export class PartnerErrorHandler {
  constructor(partnerResult = {}) {
    this.partnerResult = partnerResult;
  }

  formatWithPartner() {
    const { partnerName = '' } = this.partnerResult;
    return translation(preciseMsgMapping.get(needParseErrorCodeMap.with_partner), [partnerName]);
  }

  formatWithExpirePartner() {
    const { partnerName = '', expireDate = '' } = this.partnerResult;
    return translation(preciseMsgMapping.get(needParseErrorCodeMap.expire_partner), [partnerName, dateTimeFormat(expireDate)]);
  }

  getErrorMsgWithErrorCode() {
    const { errorCode = '', errorMessage = '' } = this.partnerResult;

    switch (errorCode) {
      case needParseErrorCodeMap.general_error:
        return errorMessage;
      case needParseErrorCodeMap.with_partner:
        return this.formatWithPartner();
      case needParseErrorCodeMap.expire_partner:
        return this.formatWithExpirePartner();
      default:
        return '';
    }
  }
}
